import { render, staticRenderFns } from "./PartnershipRequestButton.vue?vue&type=template&id=696c5088&"
import script from "./PartnershipRequestButton.vue?vue&type=script&lang=js&"
export * from "./PartnershipRequestButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports